import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"btn-add",attrs:{"fab":"","dark":"","color":"primary","fixed":"","bottom":"","right":""},on:{"click":_vm.goToCreate}},[_c(VIcon,[_vm._v("add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }